import { createSelectors } from 'app/api/redux-jigsaw/userdata/utils/selector-utils';

const base = createSelectors('notes');

export const getNotes = base.getItems;
export const areNotesPending = base.isPending;
export const hasNotes = base.hasItems;
export const isNoteUpdateProcessing = base.isUpdateProcessing;
export const hasNoteLoadError = base.hasError;



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/userdata/notes/selectors.js